import {
  FOTOGRAFIAS_ADD_PHOTO,
  FOTOGRAFIAS_STOP_UPLOAD,
  FOTOGRAFIAS_SET_CURRENT_PHOTO,
  FOTOGRAFIAS_SET_RECURSOS_PHOTO,
} from '../../actions/constants/sistemaSubidaFotografias/fotografias.constants';

const initialState = {
  recursos: [],
  uploading: false,
  currentPhoto: undefined,
};

export default function noConformidadesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case FOTOGRAFIAS_ADD_PHOTO: {
      const { recursos } = state;
      recursos.push(payload);
      return {
        ...state, recursos, uploading: true,
      };
    }
    case FOTOGRAFIAS_SET_CURRENT_PHOTO: {
      const { currentPhoto } = payload;
      return {
        ...state, currentPhoto,
      };
    }
    case FOTOGRAFIAS_STOP_UPLOAD: {
      return {
        ...state, uploading: false,
      };
    }
    case FOTOGRAFIAS_SET_RECURSOS_PHOTO: {
      return {
        ...state, recursos: [],
      };
    }
    default:
      return state;
  }
}
